import { memo } from "react"
import type { FC } from "react"

const DownloadIconComponent: FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 3.22095C7.65482 3.22095 7.375 3.50077 7.375 3.84595L7.375 9.80157L4.73853 7.16221C4.4838 6.90719 4.07079 6.90719 3.81605 7.16221C3.56132 7.41723 3.56132 7.83069 3.81605 8.08571L7.50598 11.7797C7.64169 11.9155 7.82233 11.979 8.00003 11.9701C8.17771 11.979 8.35834 11.9155 8.49405 11.7797L12.184 8.0857C12.4387 7.83069 12.4387 7.41722 12.184 7.16221C11.9292 6.90719 11.5162 6.90719 11.2615 7.16221L8.625 9.8016V3.84595C8.625 3.50077 8.34518 3.22095 8 3.22095Z"
        fill="currentColor"
      />
      <path
        d="M3.625 13.8459C3.625 13.5008 3.90482 13.2209 4.25 13.2209L11.75 13.2209C12.0952 13.2209 12.375 13.5008 12.375 13.8459C12.375 14.1911 12.0952 14.4709 11.75 14.4709L4.25 14.4709C3.90482 14.4709 3.625 14.1911 3.625 13.8459Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const DownloadIcon = memo(DownloadIconComponent)
